import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import { AddBox } from '@material-ui/icons';
import UnpairedPaletteList from './UnpairedPaletteList';
import { hasPermission, createHistory } from '../../sc-utilities';


const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const UnpairedPalettes = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, paletteExternalInfoID: null, redirectPath: '' });

    let visible = columns && columns['UnpairedPalette'];

    const tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                <Tooltip key={`AssignTo-${rowData.PaletteExternalInfoID}`} title={translations['assign_to_existing'] || 'Assign to existing'}>
                    <IconButton
                        component='div'
                        onClick={() => redirectHandler(`/unpairedAssets/unpairedPalette-assignToExisting?PaletteExternalInfoID=${rowData.PaletteExternalInfoID}`)}
                    >
                        <AddBox />
                    </IconButton>
                </Tooltip>
            </>
        },
        {
            title: translations["external_service_type"] || 'External service type', field: 'ExternalServiceType',
            hidden: visible ? visible['ExternalServiceType'] : false,
            lookup: { 'staging_v1': translations['staging_v1'] || 'Staging V1', 'asset_v1': translations['asset_v1'] || 'Asset V1' },
            defaultFilter: ['staging_v1', 'asset_v1'],
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ExternalServiceType === 'staging_v1' ? translations['staging_v1'] || 'Staging V1' : translations['asset_v1'] || 'Asset V1'}</Typography>;
            }
        },
        {
            title: translations["type"] || 'Type', field: 'Type',
            hidden: visible ? visible['Type'] : false,
            lookup: { 'Order': translations['order'] || 'Order', 'TransportColli': translations['transport_colli'] || 'Transport Colli', 'Colli': translations['colli'] || 'Colli' },
            defaultFilter: ['Order', 'TransportColli', 'Colli'],
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.OrderID !== null ? translations['order'] || 'Order' : rowData.ColliID !== null ? translations['colli'] || 'Colli' : rowData.TransportColliID !== null ? translations['transport_colli'] || 'Transport Colli' : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Order && rowData.Order.Name ? rowData.Order.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["description"] || 'Description', field: 'Description',
            hidden: visible ? visible['Description'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Order && rowData.Order.Description ? rowData.Order.Description : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        }
    ];

    const redirectHandler = (path, paletteExternalInfoID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, paletteExternalInfoID: paletteExternalInfoID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {
                hasPermission(permissions, 'unpaired_palette_list') ?
                    <UnpairedPaletteList
                        tableColumns={tableColumns}
                        redirectHandler={redirectHandler}
                        tableRef={tableRef}
                    /> : null
            }
        </div >
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(UnpairedPalettes));